if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        /*
         * Prefer the drawer when the theme is configured to use it.
         */
        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton?.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton?.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton?.classList.add('loading');

        this.querySelector(
          '.loading__spinner'
        )?.classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          const sections =
            this.cart.getSectionsToRender?.() || [];

          formData.append(
            'sections',
            sections.map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement?.(
            document.activeElement
          );
        }

        config.body = formData;

        const variantId = formData.get('id');

        const quantity =
          parseInt(formData.get('quantity')) || 1;

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(
            variantId,
            quantity
          );

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              try {
                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source: 'product-form',
                    productVariantId: variantId,
                    errors:
                      response.errors ||
                      response.description,
                    message: response.message,
                  }
                );
              } catch (error) {
                console.warn(
                  'Cart error event could not be published:',
                  error
                );
              }

              this.handleErrorMessage(
                response.description ||
                  response.message
              );

              this.dispatchCartErrorEvent(
                response.description ||
                  response.message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(
                  response.description ||
                    response.message
                )
              );

              const soldOutMessage =
                this.submitButton?.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButton?.setAttribute(
                  'aria-disabled',
                  'true'
                );

                this.submitButtonText?.classList.add(
                  'hidden'
                );

                soldOutMessage.classList.remove(
                  'hidden'
                );
              }

              this.error = true;
              return;
            }

            if (!this.cart) {
              this.resolveCartLinesUpdate(
                linesUpdateDeferred
              );

              window.location =
                window.routes.cart_url;

              return;
            }

            this.resolveCartLinesUpdate(
              linesUpdateDeferred
            );

            /*
             * Publish the cart update when supported, but never let
             * an incompatible pub/sub implementation stop the drawer.
             */
            try {
              const publishResult = publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response,
                }
              );

              if (
                publishResult &&
                typeof publishResult.catch === 'function'
              ) {
                publishResult.catch((error) => {
                  console.warn(
                    'Cart update subscriber error:',
                    error
                  );
                });
              }
            } catch (error) {
              console.warn(
                'Cart update event could not be published:',
                error
              );
            }

            this.error = false;

            const renderCart = () => {
              if (
                this.cart &&
                typeof this.cart.renderContents ===
                  'function'
              ) {
                this.cart.renderContents(response);
              } else {
                window.location =
                  window.routes.cart_url;
              }
            };

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(renderCart);
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              renderCart();
            }
          })
          .catch((error) => {
            console.error(
              'Add to cart failed:',
              error
            );

            this.handleErrorMessage(
              error.message ||
                'Something went wrong. Please try again.'
            );

            this.dispatchCartErrorEvent(
              error.message || 'Network error',
              'SERVICE_UNAVAILABLE'
            );

            linesUpdateDeferred?.reject(error);
            this.error = true;
          })
          .finally(() => {
            this.submitButton?.classList.remove(
              'loading'
            );

            if (
              this.cart?.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton?.removeAttribute(
                'aria-disabled'
              );
            }

            this.querySelector(
              '.loading__spinner'
            )?.classList.add('hidden');
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      createCartLinesUpdateEvent(
        variantId,
        quantity
      ) {
        const { CartLinesUpdateEvent } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return null;

        const deferred =
          CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [
              {
                merchandiseId: variantId,
                quantity,
              },
            ],
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;

        const { CartLinesUpdateEvent } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =
          typeof CartItems !== 'undefined'
            ? CartItems.fetchCartData()
            : fetch(
                `${routes.cart_url}.json`
              ).then((response) =>
                response.json()
              );

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) {
              return deferred.reject(
                new Error(
                  'Missing currency in cart response'
                )
              );
            }

            deferred.resolve({
              cart:
                CartLinesUpdateEvent
                  .createCartFromAjaxResponse(
                    cart
                  ),
            });
          })
          .catch((error) =>
            deferred.reject(error)
          );
      }

      dispatchCartErrorEvent(
        message,
        code
      ) {
        const { CartErrorEvent } =
          window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(
          new CartErrorEvent({
            error: message,
            code,
          })
        );
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}